var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"templates-page"},[_c('div',{staticClass:"templates"},_vm._l((_vm.templates),function(t){return _c('template-card',{key:t.uuid,attrs:{"app":t,"linked-items":_vm.getLinkedItems(t.uuid)}})}),1)])
}
var staticRenderFns = []

export { render, staticRenderFns }